import styled from 'styled-components';

import { getThemeProps } from 'ravenjs/utils/theme';

import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

const UserMenuStyledCommon = styled.div`
    background-color: ${MIGRATED_COLORS.white};
    overflow: auto;
    /**
     * Add all of the remaining styles from theme
     */
    ${getThemeProps('UserMenu.styles')}
`;

const UserMenuStyledV1 = styled(UserMenuStyledCommon)`
    ${({ theme }) => theme.media.down('md')`
        border: none;
        height: 100%;
    `};
    ${({ theme }) => theme.media.up('md')`
        border: 1px solid ${MIGRATED_COLORS.black};
        max-height: 25rem;
    `};
    border-radius: 0;
    padding: 1rem;
`;

const UserMenuStyledV2 = styled(UserMenuStyledCommon)`
    ${({ theme }) => theme.media.down('md')`
        border: none;
        height: 100%;
         width: auto;
    `};
    ${({ theme }) => theme.media.up('md')`
        border: 1px solid ${MIGRATED_COLORS.grey22};
    `};
    border-radius: 4px 4px 8px 8px;
    padding: 24px;
    box-shadow: 0 2px 8px -2px ${MIGRATED_COLORS.grey61};
    top: 82px;
`;

export { UserMenuStyledV1, UserMenuStyledV2 };
export default UserMenuStyledV1;
